module.exports = __webpack_public_path__ + "static/media/alienship.7f18661e.png";